import React, { useRef, useState, useContext } from 'react';
import {
  useRouteMatch,
  Switch,
  Route,
  NavLink,
  useLocation
} from 'react-router-dom';
import { Company } from './company/Company';
import styled, { keyframes } from 'styled-components';
import { SettingsIcon3 } from '../../assets/svg/SettingsIcon3';
import { CompanyIcon } from '../../assets/svg/CompanyIcon';
import { OrganisationIcon } from '../../assets/svg/OrganisationIcon';
import { OrganisationTypeIcon2 } from '../../assets/svg/OrganisationTypeIcon2';
import { PeopleIcon } from '../../assets/svg/PeopleIcon';
import { ScorecardIcon } from '../../assets/svg/ScorecardIcon';
import { DashboardIcon } from '../../assets/svg/DashboardIcon';
import { ProfileIcon } from '../../assets/svg/ProfileIcon';
import { ScorecardSettings } from './Scorecard/ScorecardSettings';
import { TitleText } from '../../ui/Text';
import OrganisationSettings from './Organisation/OrganisationSettings';
import OrganizationTypeSettings from './OrganizationType/OrganizationTypeSettings';
import PeopleSettings from './PeopleSettings/PeopleSettings';
import ScorecardListView from './Scorecard/ScorecardListView';
import { Period } from './period/Period';
import { ScorecardConfig } from './ScorecardConfig/ScorecardConfig';
import { StrategymapConfig } from './strategymapConfig/StrategymapConfig';
import { StrategyMapIcon2 } from '../../assets/svg/StrategyMapIcon2';
import GlobalSettings from './GlobalSettings/GlobalSettings';
import Profile from './Profile/Profile';
import { AuthContext } from '../../context/AuthContext';
import StrategymapListView from './strategymapConfig/StrategymapListView';
import ReviewDepartmentsSettings from './ReviewDepartments/ReviewDepartmentsSettings';
import GroupSettings from './GroupSettings/GroupSettings';
import ScoringMatrix from './ScoringMatrix/ScoringMatrix';
import GlobalSearchKpi from './GlobalSearch/GlobalSearchKpi';
import useAuth from '../../hooks/useAuth';

export const Settings = () => {
  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();
  const auth = useAuth();
  const { isAdmin } = auth;

  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');
  const [activeContainer, setActiveContainer] = useState('');

  const content = useRef<any>(null);

  function toggleAccordion(container) {
    setActiveContainer(container);

    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(
      setActive === 'active' ? '0px' : `${content.current.scrollHeight}px`
    );
  }

  return (
    <>
      <SettingsContainer>
        <SettingsSideNav isAdmin={isAdmin()}>
          <SettingsTitle>
            <SettingsIcon3 isActive={true} />
            <TitleText>Settings</TitleText>
          </SettingsTitle>
          {isAdmin() ? (
            <>
              <NavItem to={`${url}/company`}>
                <CompanyIcon isActive={pathname.includes('company')} />
                <h5>Company</h5>
              </NavItem>
              <NavItem to={`${url}/organisations`}>
                <Route>
                  {props => {
                    const matches =
                      props.location.pathname === `${url}/organisations`;
                    return (
                      <OrganisationIcon
                        opacity={matches ? '100%' : '30%'}
                        isActive={matches}
                      />
                    );
                  }}
                </Route>
                {/*  */}
                <h5>Organizations</h5>
              </NavItem>
              <NavItem to={`${url}/organisationstype`}>
                <OrganisationTypeIcon2
                  opacity={
                    pathname.includes('organisationstype') ? '100%' : '30%'
                  }
                  isActive={pathname.includes('organisationstype')}
                />
                <h5>Organisation Type</h5>
              </NavItem>
              <NavItem to={`${url}/people`}>
                <PeopleIcon isActive={pathname.includes('people')} />
                <h5>People</h5>
              </NavItem>
              <NavItem to={`${url}/period`}>
                <PeopleIcon isActive={pathname.includes('period')} />
                <h5>Period</h5>
              </NavItem>

              <AccordionNavContainer>
                <NavItem
                  to={`${url}/bscSettings`}
                  onClick={() => toggleAccordion('config')}
                >
                  <ScorecardIcon
                    opacity={pathname.includes('bscSettings') ? '100%' : '30%'}
                    isActive={pathname.includes('bscSettings')}
                  />
                  <h5>BSC Settings</h5>
                </NavItem>

                <AccordionItemsWrapper
                  ref={content}
                  style={{ maxHeight: `${setHeight}` }}
                >
                  <Devider />
                  <ListItem to={`${url}/bscSettings/scorecardConfig`}>
                    KPI Database
                  </ListItem>
                  <Devider />
                  <ListItem to={`${url}/bscSettings/globalSettings`}>
                    Global Settings
                  </ListItem>
                  <Devider />
                  <ListItem to={`${url}/bscSettings/scoringMatrix`}>
                    Scoring Matrix
                  </ListItem>
                  <Devider />
                  <ListItem to={`${url}/bscSettings/globalSearchKpi`}>
                    Global Search KPIs
                  </ListItem>
                </AccordionItemsWrapper>
              </AccordionNavContainer>
            </>
          ) : null}
          <NavItem to={`${url}/reviewdepartments`}>
            <PeopleIcon isActive={pathname.includes('reviewdepartments')} />
            <h5>360 Organisations</h5>
          </NavItem>
          <NavItem to={`${url}/reviewgroups`}>
            <PeopleIcon isActive={pathname.includes('reviewgroups')} />
            <h5>Groups</h5>
          </NavItem>
          <NavItem
            to={`${url}/scorecard`}
            onClick={() =>
              setActiveContainer(
                activeContainer === 'scorecards' ? '' : 'scorecards'
              )
            }
          >
            <Route>
              {props => {
                const matches = props.location.pathname === `${url}/scorecard`;
                return (
                  <ScorecardIcon
                    opacity={matches ? '100%' : '30%'}
                    isActive={matches}
                  />
                );
              }}
            </Route>

            <h5>Scorecards</h5>
          </NavItem>
          {/* <AccordionNavContainer>
            <NavItem
              to={`${url}/scorecard`}
              onClick={() =>
                setActiveContainer(
                  activeContainer === "scorecards" ? "" : "scorecards"
                )
              }
            >
              <ScorecardIcon
                opacity={pathname.includes("scorecard") ? "100%" : "30%"}
                isActive={pathname.includes("scorecard")}
              />
              <h5>Scorecard</h5>
            </NavItem>
            <AccordionItemsWrapper
              ref={content}
              style={
                activeContainer === "scorecards"
                  ? { maxHeight: `100%` }
                  : { maxHeight: "0px" }
              }
            >
              <Devider />
              <ListItem to={`${url}/scorecard/active`}>Active</ListItem>
              <Devider />
              <ListItem to={`${url}/scorecard/pending`}>Pending</ListItem>
              <Devider />
              <ListItem to={`${url}/scorecard/archived`}>Archived</ListItem>
            </AccordionItemsWrapper>
          </AccordionNavContainer> */}

          {/* **************************************** */}
          {isAdmin() && (
            <AccordionNavContainer>
              <NavItem
                to={`${url}/strategymap`}
                onClick={() =>
                  setActiveContainer(
                    activeContainer === 'strategymap' ? '' : 'strategymap'
                  )
                }
              >
                <StrategyMapIcon2
                  opacity={pathname.includes('strategymap') ? '100%' : '30%'}
                  isActive={pathname.includes('strategymap')}
                />
                <h5>Strategy Map</h5>
              </NavItem>
              <AccordionItemsWrapper
                ref={content}
                style={
                  activeContainer === 'strategymap'
                    ? { maxHeight: `100%` }
                    : { maxHeight: '0px' }
                }
              >
                <Devider />
                <ListItem to={`${url}/strategymap/active`}>Active</ListItem>
                <Devider />
                <ListItem to={`${url}/strategymap/pending`}>Pending</ListItem>
                <Devider />
                <ListItem to={`${url}/strategymap/archived`}>Archived</ListItem>
              </AccordionItemsWrapper>
            </AccordionNavContainer>
          )}

          {/* **************************************** */}

          <NavItem to={`${url}/profile`}>
            <ProfileIcon
              opacity={pathname.includes('profile') ? '100%' : '30%'}
              isActive={pathname.includes('profile')}
            />
            <h5>Profile</h5>
          </NavItem>
        </SettingsSideNav>
        <Switch>
          <Route path={`${path}/company`} component={Company} />
          <Route path={`${path}/scorecard/:id`} component={ScorecardSettings} />
          <Route path={`${path}/scorecard`} component={ScorecardListView} />
          {/* <Route
            path={`${path}/scorecard/archived`}
            component={ScorecardListView}
          />
          <Route
            path={`${path}/scorecard/active`}
            component={ScorecardListView}
          /> */}
          <Route
            path={`${path}/strategymap/:status/:strategymapId`}
            component={StrategymapConfig}
          />

          <Route
            path={`${path}/strategymap/:status`}
            component={StrategymapListView}
          />

          <Route
            path={`${path}/organisations`}
            component={OrganisationSettings}
          />
          <Route
            path={`${path}/organisationstype`}
            component={OrganizationTypeSettings}
          />
          <Route path={`${path}/people`} component={PeopleSettings} />
          <Route
            path={`${path}/reviewdepartments`}
            component={ReviewDepartmentsSettings}
          />
          <Route path={`${path}/reviewgroups`} component={GroupSettings} />
          <Route path={`${path}/period`} component={Period} />
          <Route path={`${path}/profile`} component={Profile} />
          <Route
            path={`${path}/bscSettings/scorecardConfig`}
            component={ScorecardConfig}
          />
          <Route
            path={`${path}/bscSettings/globalSettings`}
            component={GlobalSettings}
          />
          <Route
            path={`${path}/bscSettings/scoringMatrix`}
            component={ScoringMatrix}
          />
          <Route 
            path={`${path}/bscSettings/globalSearchKpi`}
            component={GlobalSearchKpi}
          />
        </Switch>
      </SettingsContainer>
    </>
  );
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const SettingsContainer = styled.div`
  display: grid;
  grid-template-columns: 18em auto;
  background-color: #f5f6fb;
`;
const SettingsSideNav = styled.div<{ isAdmin: boolean }>`
  display: grid;
  grid-template-rows: ${props =>
    props.isAdmin
      ? '3em 2.5em 2.5em 2.5em 2.5em 2.5em minmax(min-content, max-content) 2.5em 2.5em 2.5em minmax(min-content, max-content) 2.5em'
      : '3em  2.5em 2.5em 2.5em'};
  row-gap: 1rem;
  margin: 1rem;
  animation: ${fadeIn} 0.3s ease-out;
`;

const SettingsTitle = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 5fr;
  padding-left: 1em;
  align-items: center;
`;

const NavItem = styled(NavLink)`
  display: grid;
  grid-template-columns: 0.5fr 5fr;
  text-decoration: none;
  align-items: center;
  align-content: center;
  column-gap: 0.5rem;
  padding-left: 1em;
  height: 2.5rem;
  color: #cdd3de;
  font-size: 18px;
  transition: background-color 0.3s, box-shadow 0.3s, color 0.3s;
  &:hover {
    background-color: #e0e0e0;
    color: #000;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  &.active {
    background-color: #fff;
    border-radius: 0.5em;
    box-shadow: 20px 20px 20px rgba(55, 81, 255, 0.1);
    color: #214160;
    opacity: 100%;
  }
`;

const AccordionNavContainer = styled.div`
  display: grid;
  grid-template-rows: 2.5em auto;
`;

const AccordionItemsWrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(4, 3.5em);
  grid-template-columns: 1em 12em;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  animation: ${slideIn} 0.3s ease-out;
  margin-left: 0.7em;
`;

const ListItem = styled(NavLink)`
  align-items: center;
  align-content: center;
  justify-items: center;
  padding-left: 1em;
  text-decoration: none;
  border-radius: 0.5em;
  background-color: #fff;
  font-weight: 450;
  color: #214160;
  font-size: 12px;
  padding: 0.5em;
  line-height: 2em;
  margin-top: 1.5em;
  width: 90%;
  transition: background-color 0.3s, box-shadow 0.3s, color 0.3s;
  &.active {
    background-color: #01a8ce;
    color: #fff;
    margin-left: 1em;
  }
`;

const Devider = styled.div`
  border-left: 1px dotted rgba(55, 81, 255, 0.1);
  border-bottom: 1px dotted rgba(55, 81, 255, 0.1);
  margin-left: 1em;
  margin-bottom: 1em;
`;
